/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {AdminGroupChooser} from '@ion/features/src/entities/group/AdminGroupChooser';
import {GroupAssignmentAccountChooserProps} from './GroupAssignmentAccountChooser';
import {
  GroupAssignmentDetailsFields,
  GroupAssignmentFormProps
} from './GroupAssignmentDetailsForm';

export interface ReplaceGroupAssignmentActionProps extends
  GroupAssignmentAccountChooserProps,
  GroupAssignmentFormProps {}

const useStyles = makeStyles(() => ({
  paddingTop25 : {
    paddingTop : '25px'
  },
  errorMessage : {
    color      : dlsColor('caRed'),
    fontSize   : '12px',
    fontFamily : 'Roboto',
    fontWeight : 400
  }
}));

/**
 * Re-usable hook for replacing group.
 */
export const ReplaceGroupAssignmentAction = ({
  replaceGroups,
  handleFromGroupChooser,
  fromGroup,
  toGroup,
  formState,
  path,
  areGroupsLoading = false,
  isFromGroupEmpty = false
}: ReplaceGroupAssignmentActionProps) => {
  const classes       = useStyles();
  const isGroupIdSame = fromGroup?.id === toGroup?.id;

  return (
    <div className={classes.paddingTop25}>
      <AdminGroupChooser required
        fieldLabel={translate(`${path}.fromGroup`)}
        groupOptions={replaceGroups}
        loading={areGroupsLoading}
        onChange={handleFromGroupChooser}
        hasError={formState[GroupAssignmentDetailsFields.REPLACE_FROM_GROUP]?.error ||
          (fromGroup && toGroup && isGroupIdSame)}
        errorText={(fromGroup && toGroup && isGroupIdSame) ? translate(`${path}.groupsNotSame`)
          : translate(`${path}.error`)}
        defaultValue={formState[GroupAssignmentDetailsFields.REPLACE_FROM_GROUP]?.value} />
      {isFromGroupEmpty && (
        <span className={classes.errorMessage}>{translate('common:editors.shared.required')}</span>
      )}
    </div>
  );
};

export default ReplaceGroupAssignmentAction;
